import { Button, Modal } from "antd";
import React, { Component } from "react";
class RevisionNote extends Component {
  state = {};

  render() {
    const {
      onCancel,
      visible,
      name,
      editCb,
      fromTable,
      data,
      canEdit,
      viewMore,
    } = this.props;
    const footers = [
      <Button key="cancel" onClick={onCancel}>
        Close
      </Button>,
    ];

    if (canEdit) {
      footers.push(
        <Button key="edit" onClick={editCb}>
          Edit Revision
        </Button>
      );
    }

    if (fromTable) {
      const jsx = (
        <Button key="detail" type="primary" onClick={viewMore}>
          View Full Details
        </Button>
      );

      footers.push(jsx);
    }

    return (
      <Modal
        className="revision-note"
        footer={footers}
        maskClosable={false}
        onCancel={onCancel}
        title={
          <span>
            <h3>
              {name} <span style={{ color: "grey" }}>Revision Note</span>{" "}
            </h3>
          </span>
        }
        visible={visible}
      >
        {data.note}
      </Modal>
    );
  }
}

export default RevisionNote;



// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/Modals/RevisionNote.js